module.exports = __webpack_public_path__ + "img/ticket4_p.440e4a3a.svg";